import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosPersonReferenceModalService } from 'src/app/@core/services/pos-person-reference-modal.service';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { ColumnTable } from 'src/app/models/column-table';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { Paging } from 'src/app/models/page';
import { PersonalReferenceTable } from 'src/app/models/table-models/personal-reference-table';
import { OnbaseService } from 'src/app/services/onbase.service';


@Component({
  selector: 'app-person-references-information-step',
  templateUrl: './person-references-information-step.component.html',
  styleUrls: ['./person-references-information-step.component.sass']
})
export class PersonReferencesInformationStepComponent implements OnInit {

  constructor(private referenceModal: PosPersonReferenceModalService, private confirmService: PosConfirmationService, private onbaseService: OnbaseService) {
  }

  @Input() personReferencesInformationform: FormArray = new FormArray([]);
  @Input() disabled = false;
  personReferenceTable: Paging<Array<PersonalReferenceTable>> = new Paging([]);
  @Input() isEdit = false;
  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  familyRelationships: Array<{ key: string, value: string }> = [];
  @Input() isShortFormActiveForPlan = false;
  async ngOnInit(): Promise<void> {
    this.personReferencesInformationform.valueChanges.subscribe(async s => {
      if (this.onbaseCatalogue.economicActivity.length == 0) {
        this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
      }
      this.familyRelationships = ObjectUtils.objectToArray(this.onbaseCatalogue.naturalRelation);
      if (this.isEdit) {
        this.personReferenceTable = new Paging([]);
        (s as Array<any>).forEach((f, i) => {
          this.personReferenceTable.content.push({
            code: i,
            relationship: this.familyRelationships.find(s => s.key == f.familyRelationship)?.value || f.familyRelationship,
            fullName: `${f.firstName} ${f.middleName} ${f.lastName} ${f.secondLastName}`,
            phone: f.mobilePhone,
            status: this.personReferencesInformationform.at(i).valid
          });


        })
        this.personReferenceTable = new Paging(this.personReferenceTable.content);

      }
    });


  }


  getPersonalReferencesHeaders() {
    return [
      new ColumnTable("fullName", "Nombre"),
      new ColumnTable("phone", "Teléfono"),
      new ColumnTable("relationship", "Parentesco"),
      new ColumnTable("code", "Opciones", {
        type: "action", actions: [
          {
            fn: async (row: PersonalReferenceTable) => {

              let formGroup = this.personReferencesInformationform.at(row.code) as FormGroup;
              await this.referenceModal.show(formGroup,
                (f: FormGroup) => {
                  this.personReferencesInformationform.removeAt(row.code);
                  this.personReferencesInformationform.insert(row.code, f);
                  this.updateTable(f, row.code);
                },this.isShortFormActiveForPlan);
            },
            icon: "fa fa-pencil",
            isDisabled: false,
            tooltip: "Editar",
            disabledFn: () => { return this.disabled; }
          },
          {
            fn: async (row: PersonalReferenceTable) => {
              const result = await this.confirmService.showAsync("Advertencia", "¿Está seguro de eliminar el registro?", ModalDialogType.WARNING);
              if (result) {
                this.personReferencesInformationform.removeAt(row.code);
                this.deleteFromTable(row.code);
              }
            },
            icon: "fa fa-trash",
            isDisabled: false,
            tooltip: "Delete",
            disabledFn: () => { return this.disabled; }
          }
        ]
      }),
      new ColumnTable("status", "", { type: "hidden" }),
    ];
  }

  private deleteFromTable(code: number) {
    this.personReferenceTable.content = this.personReferenceTable.content.filter(f => f.code != code);
    this.updateCodes(this.personReferenceTable.content);
    this.personReferenceTable = new Paging(this.personReferenceTable.content);
  }

  async addReference() {
    await this.referenceModal.show(this.configureNewForm(), (f: FormGroup) => {
      this.personReferencesInformationform.push(f);
      this.personReferencesInformationform.markAsDirty();
      if (!this.isEdit) {
        this.updateTable(f);
      }
    },this.isShortFormActiveForPlan);
  }

  private updateTable(f: FormGroup, code?: number) {

    let personReference = new PersonalReferenceTable();
    if (code != undefined) {
      personReference = this.personReferenceTable.content.find(f => f.code == code) || new PersonalReferenceTable();
    }
    personReference.fullName = `${f.value.firstName} ${f.value.middleName} ${f.value.lastName} ${f.value.secondLastName}`;
    personReference.phone = f.value.mobilePhone;
    personReference.relationship = this.familyRelationships.find(s => s.key == f.value.relationshipType)?.value || f.value.relationshipType;
    personReference.status = f.valid;
    if (code == undefined) {
      this.personReferenceTable.content.push(personReference);
    }

    this.updateCodes(this.personReferenceTable.content);
    this.personReferenceTable = new Paging(this.personReferenceTable.content);
  }

  configureNewForm() {
    let form = new FormGroup({
      firstName: new FormControl("", Validators.required),
      middleName: new FormControl(""),
      lastName: new FormControl("", Validators.required),
      secondLastName: new FormControl(""),
      familyRelationship: new FormControl("", Validators.required),
      mobilePhone: new FormControl("", Validators.required),
      phone: new FormControl(""),
      workPhone: new FormControl(""),
      workPhoneExtension: new FormControl(""),
    });

    form.get("familyRelationship")?.markAsDirty()
    return form;
  }
  private updateCodes(content: PersonalReferenceTable[]) {
    content.forEach((f, i) => f.code = i);
  }
}
